export const metrics = {
  responseEndTime: 'metric1',
  domLoadTime: 'metric2',
  windowLoadTime: 'metric3',
  ttfb: 'metric4',
  stalled: 'metric5',
  download: 'metric6',
  startDuration: 'metric7',
  endDuration: 'metric8',
  cachedResources: 'metric9',
};

export const dimensions = {
  uid: 'dimension1',
  orgId: 'dimension2',
  hpInternal: 'dimension3',
  roles: 'dimension4',
  orgType: 'dimension5',
  selfProvisioned: 'dimension6',
  entityType: 'dimension7',
  windowId: 'dimension8',
  hitId: 'dimension9',
  hitTime: 'dimension10',
  mobileDeviceId: 'dimension11',
  appBuContext: 'dimension12',
  visitingOrgId: 'dimension13',
};

/**
 * For use in the APP BU Context custom dimension
 */
export const APP_BU_CONTEXT = {
  Indigo: 'Indigo',
  Latex: 'Latex',
  DesignJet: 'DesignJet',
  Scitex: 'Scitex',
  PWP: 'PWP',
  ThreeD: '3D',
};



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/core/analytics/ga-custom-defs.js